import { Component } from '@angular/core';
import { ModalService } from '@core/services';


@Component({
  moduleId: module.id,
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.less']
})
export class FormModalComponent  {

  public errorText: string;
  public comments: string;

  constructor(private modalService: ModalService) {
   }

  public setErrorText(errorText: string) {
    this.errorText = errorText;
  }


  submitFeedback() {
    this.modalService.btnEvent.emit({ type: 'feedback', comments: this.comments ? this.comments.trim() : this.comments });
    this.modalService.hideModal();
  }

}
